import * as React from 'react'
import UserModel from '../sdk/api/models/user'

export const UserContext = React.createContext<{ user: UserModel, setUser: (user: UserModel) => void }>(undefined as any)
export const UserContextProvider = UserContext.Provider
export const UserContextConsumer = UserContext.Consumer